import { render } from "./AppLayout_9_3.vue?vue&type=template&id=13b72d89&scoped=true"
import script from "./AppLayout_9_3.vue?vue&type=script&lang=js"
export * from "./AppLayout_9_3.vue?vue&type=script&lang=js"

import "./AppLayout_9_3.vue?vue&type=style&index=0&id=13b72d89&scoped=true&lang=css"

import exportComponent from "C:\\Proyectos\\Crypto\\dex\\github\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b72d89"]])

export default __exports__